import { Progress } from '@radix-ui/react-progress'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthLayout from '../components/AuthLayout'

export default function AuthRegisterLoadingPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/verify-sign-up')
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <AuthLayout>
      <div className='space-y-6'>
        <div className='space-y-4'>
          <h1 className='text-2xl font-bold text-gray-900'>Logging in</h1>
          <Progress value={65} className='h-2' />
        </div>
      </div>
    </AuthLayout>
  )
}
